/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc
 */

export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const MarketingEmailCoordinatesTypename = 'com.hubspot.personalize.models.MarketingEmailCoordinates';
export const SegmentTargetingConfigTypename = 'com.hubspot.personalize.models.SegmentTargetingConfig';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const createVariantRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'createVariant',
  auth: 'app',
  fingerprint: 'FYA78ZTP_Mz5Daaw1LaPsjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalization',
  auth: 'app',
  fingerprint: 'JZhCxIAXXPo4-bu8O4MxSjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizationStrategy',
  auth: 'app',
  fingerprint: 'ojW6h-er-855_hIxQgY7zzCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizedDefaultRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizedDefault',
  auth: 'app',
  fingerprint: 'Gq2BAV_gwRePwCyCO6ymWDCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};